import { useCallback, useContext } from 'react';
import DashboardGadgetsContext from '../../../../../../contexts/DashboardGadgetsContext';
import usesFieldInPlates from './usesFieldInPlates';

const useGetFieldDashboardGadgetFilterUsage = () => {
  const { allGadgets } = useContext(DashboardGadgetsContext);

  const getFieldDashboardGadgetFilterUsage = useCallback(
    (field: string, dataset: string) => {
      const filterUsage: DashboardGadget[] = [];
      allGadgets.forEach((g) => {
        if (
          (usesFieldInPlates(g.scope, field, dataset) ||
            usesFieldInPlates(g.drillDowns, field, dataset)) &&
          !filterUsage
            .map((usageGadget) => usageGadget.chartDef.id)
            .includes(g.chartDef.id)
        ) {
          filterUsage.push(g);
        }
      });
      return filterUsage;
    },
    [allGadgets],
  );

  return getFieldDashboardGadgetFilterUsage;
};

export default useGetFieldDashboardGadgetFilterUsage;
